import { initializeApp } from 'firebase/app';
import { getAuth, signInWithRedirect, getRedirectResult, signInWithPopup, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

// online
const firebaseConfig = {
  apiKey: "AIzaSyBpb17ZTG1CUuCpZEEd1rgtN1DwClyG-Ks",
  authDomain: "papibang-10683.firebaseapp.com",
  projectId: "papibang-10683",
  storageBucket: "papibang-10683.firebasestorage.app",
  messagingSenderId: "884280731895",
  appId: "1:884280731895:web:2c951e5515dfd7db93cbf2",
  measurementId: "G-3QX04QGRX3"
};

// pre
// const firebaseConfig = {
//   apiKey: "AIzaSyCKEgCi6rdku_HYocf11jcBNGvaNNFBKwk",
//   authDomain: "papibangpre.firebaseapp.com",
//   projectId: "papibangpre",
//   storageBucket: "papibangpre.firebasestorage.app",
//   messagingSenderId: "473132553985",
//   appId: "1:473132553985:web:cc434187e2f337a9fead00",
//   measurementId: "G-VJ5VY5GVEB"
// };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default {
  app,
  auth
};